import { quadInOut } from 'svelte/easing';

export default function afterimage(
  node: Element,
  { delay = 0, duration = 500, easing = quadInOut, amount = 20, opacity = 0 }
) {
  const style = getComputedStyle(node);
  const targetOpacity = +style.opacity;
  const od = targetOpacity * (1 - opacity);
  const f = style.filter === 'none' ? '' : style.filter;

  return {
    delay,
    duration,
    easing,
    css: (t: number, u: number) => {
      return `
        filter: ${f} blur(${u * amount}px) saturate(${100 + u * 280}%) ;
        opacity: ${targetOpacity - od * u}; 
        `;
    }
  };
}
